import { useCallback, useMemo } from 'react';

import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { isHighwayArea } from '@/modules/floorplanDesign/helpers';
import { useAppStore } from '@/modules/app/store/useAppStore';

import { HIGHWAY_ARROW_ID } from '../constants/elements';
import { CanvasServiceFactory } from '../services/Canvas/CanvasServiceFactory';
import { useCanvasStore } from '../store';
import { HideElementsService } from '@/modules/canvas';

export const useEditStart = () => {
  const canvasSvc = useMemo(() => CanvasServiceFactory.getInstance().createCanvasService(), []);

  // Read the selection and area when the edit starts instead of subscribing to them,
  // so this callback (and the canvas event registration that depends on it) stays stable.
  const editStarted = useCallback(() => {
    const { selectedIds } = useAppStore.getState();
    if (selectedIds.length !== 1) {
      return;
    }

    const area = useFloorplanDesignStore.getState().getAreaById(selectedIds[0]);
    if (area === undefined || !isHighwayArea(area)) {
      return;
    }

    const canvas = useCanvasStore.getState().instance;
    if (!canvas) return;
    const element = canvas.getElement(area.id);
    if (!element) return;

    if (element.type !== 'AngledHighway' && element.type !== 'LinePath') {
      return;
    }

    const componentIds: string[] = area.segments.map((e) => `${e.id}-${HIGHWAY_ARROW_ID}`);

    // update canvas
    HideElementsService.instance.hideFloorplanElements([element.id]);
    canvasSvc.removeCanvasElements({ method: 'byId', ids: componentIds });
  }, [canvasSvc]);

  return { editStarted };
};
